const judgeUserAgent = function () {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return "ios";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return "android";
  } else {
    return "pc";
  }
};
const judgeBrowser = function () {
  const OsObject = navigator.userAgent;
  // 包含「Opera」文字列
  if (OsObject.indexOf("Opera") !== -1) {
    return "Opera";
  } else if (OsObject.indexOf("MSIE") !== -1) {
    // 包含「MSIE」文字列
    return "MSIE";
  } else if (OsObject.indexOf("Chrome") !== -1) {
    // 包含「chrome」文字列 ，不过360浏览器也照抄chrome的UA
    return "Chrome";
  } else if (OsObject.indexOf("UCBrowser") !== -1) {
    // 包含「UCBrowser」文字列
    return "UCBrowser";
  } else if (OsObject.indexOf("BIDUBrowser") !== -1) {
    // 包含「BIDUBrowser」文字列
    return "BIDUBrowser";
  } else if (OsObject.indexOf("Firefox") !== -1) {
    // 包含「Firefox」文字列
    return "Firefox";
  } else if (OsObject.indexOf("Netscape") !== -1) {
    // 包含「Netscape」文字列
    return "Netscape";
  } else if (OsObject.indexOf("Safari") !== -1) {
    // 包含「Safari」文字列
    return "Safari";
  } else {
    return undefined;
  }
};
/**
 * 判断是否在pc端打开
 */
const isPC = () => {
  const system = {
    win: false,
    mac: false,
    xll: false,
  };
  // 检测平台
  const p = navigator.platform;

  system.win = p.indexOf("Win") === 0;
  system.mac = p.indexOf("Mac") === 0;
  system.x11 = p === "X11" || p.indexOf("Linux") === 0;

  if (system.win || system.mac || system.xll) {
    return true;
  }
  return false;
};
const isApp = /jzh/.test(navigator.userAgent);
export { judgeUserAgent, judgeBrowser, isPC, isApp };
